import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { spendingTrendsActions } from '@store/actions/spending-trends.actions';
import { filter, of, switchMap } from 'rxjs';
import { ApiSpendingService } from '@core/api/services/consumption/api-spending.service';
import { SpendingTrendsMapper } from '@core/domain/mappers/consumption/spending-trends.mapper';
import { catchError, map } from 'rxjs/operators';
import { SpendingTrendsElement } from '@core/domain/model/consumption/spending-trends.model';

@Injectable()
export class SpendingTrendsEffects {
  constructor(
    private readonly _actions$: Actions,
    private readonly _api: ApiSpendingService
  ) {}

  readonly fetchCurrentSpending$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(spendingTrendsActions.filterSpending),
      filter(({ filter }) => filter.installations && filter.installations.length > 0),
      switchMap(({ filter }) => {
        return this._api.getSpending(SpendingTrendsMapper.filterToSpendingApi(filter)).pipe(
          map((response) => SpendingTrendsMapper.apiSpendingToDomain(filter, response.data)),
          map((data) => spendingTrendsActions.setSpending({ ...data })),
          catchError(() => of(spendingTrendsActions.setSpending({ current: [], previous: [] })))
        );
      })
    );
  });

  readonly fetchCurrentConsumption$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(spendingTrendsActions.filterConsumption),
      switchMap(({ filter }) =>
        this._api.getAccumulatedConsumption(SpendingTrendsMapper.filterToCurrentAccumulatedApi(filter)).pipe(
          map((response) => SpendingTrendsMapper.apiAccumulatedToDomain(response.data)),
          catchError(() => of<SpendingTrendsElement[]>([])),
          map((data) => spendingTrendsActions.setCurrentConsumption({ data }))
        )
      )
    );
  });

  readonly fetchPreviousConsumption$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(spendingTrendsActions.filterConsumption),
      switchMap(({ filter }) =>
        this._api.getAccumulatedConsumption(SpendingTrendsMapper.filterToPreviousAccumulatedApi(filter)).pipe(
          map((response) => SpendingTrendsMapper.apiAccumulatedToDomain(response.data)),
          catchError(() => of<SpendingTrendsElement[]>([])),
          map((data) => spendingTrendsActions.setPreviousConsumption({ data }))
        )
      )
    );
  });
}
